import { ExportReportType, POLICY_CATEGORY_LIST } from "@sscs/types";
import {
  AuthType,
  FileSoftwareInfo,
  UrlImportData,
  VersionSoftwareInfo,
} from "Types";

export const PORTAL_POLICY_CATEGORY_LIST = POLICY_CATEGORY_LIST.filter(
  (category) => category !== "yara",
);

export const UNSUPPORTED_URL = "Unsupported URL";

export const URL_IMPORT_AUTH_TYPE: Record<AuthType, AuthType> = {
  basic: "basic",
  token: "token",
  none: "none",
};

export const FILE_SOFTWARE_INFO_DATA: FileSoftwareInfo = {
  category: "Other",
  license: "Unknown",
  platform: "Other",
  architecture: "Generic",
  product: "",
  publisher: "Unknown",
  version: "Generic",
  notify_on_completion: false,
};

export const VERSION_SOFTWARE_INFO_DATA: VersionSoftwareInfo = {
  ...FILE_SOFTWARE_INFO_DATA,
  version: "",
  predecessor_id: null,
  replace: false,
  force: true,
  release_date: null,
  is_released: false,
};

export const DEFAULT_URL_IMPORT_DATA: UrlImportData = {
  url: "",
};

export const REPORT_TYPE_REPRO = "repro";
export const REPORT_TYPE_VERSION = "version";

// needs to match CLI names
export const REPORT_EXPORT_FILE_NAME: Record<ExportReportType, string> = {
  cve: "report.cve.csv",
  cycloneDX: "report.cyclonedx.json",
  json: "report.rl.json",
  safe: "report.rl-safe",
  sarif: "report.sarif.json",
  spdx: "report.spdx.json",
  summaryPdf: "report.summary.pdf",
  uri: "report.uri.csv",
};

export const REPORT_EXPORT_HELPER_LABEL: Record<ExportReportType, string> = {
  cve: "Vulnerabilities",
  cycloneDX: "SBOM",
  json: "Analysis report",
  safe: "Full report",
  sarif: "Issues",
  spdx: "SBOM",
  summaryPdf: "Summary",
  uri: "Networking",
};

export const FILESTREAM_PURL = {
  projectName: "filestream",
  packageName: "file",
};

export const REPORT_RETURN_TO_PREFIX = "return_to_id";
export const STORE_PROJECT_ID = "projectId";
export const STORE_PACKAGE_ID = "packageId";
export const STORE_GROUP_ID = "groupId";
export const STORE_INSIGHTS_SEARCH_ID = "insightsSearchId";
export const STORE_SIDEBAR_PREFIX = "sidebar";
export const STORE_CATALOG = "catalog";
export const STORE_CATALOG_PLATFORM = "catalogPlatform";
export const STORE_CATALOG_PACKAGE_ID = "catalogPackageId";

export const STORED_URL_DATA = [
  STORE_CATALOG_PACKAGE_ID, // platform not stored, fixed, kept when changing the group
  STORE_GROUP_ID,
  STORE_INSIGHTS_SEARCH_ID,
  STORE_PACKAGE_ID,
  STORE_PROJECT_ID,
];

export const RECAPTCHA_SCRIPT_URL =
  "https://www.google.com/recaptcha/api.js?render=explicit";

export const NO_LEVELS_DESCRIPTION =
  "If no level is selected, ReversingLabs default policy configuration will be used. \
  Configuration can be edited in the table below.";

export const LEVELS_CANNOT_BE_DISABLED =
  "SAFE levels have been enabled for the organization and cannot be disabled on group level";

export const CATALOG_PUBLISH_CONDITION =
  "Only packages with at least one approved version can be published to the catalog.";

export const DOCS_URL = "https://docs.secure.software/portal";

export const DATE_FIELD_FORMAT = "yyyy-MM-dd";

export const WHATS_NEW_SEMVER = [2026, 10, 2];
export const WHATS_NEW_CHECK_RELEASE = WHATS_NEW_SEMVER.join(".");

export const MAX_PROJECT_NAME_LENGTH = 200;
export const MAX_PACKAGE_NAME_LENGTH = 200;

export const USER_REMOVED = "User removed";

export const NOTIFY_ON_COMPLETION_LABEL = "Email me when analysis is complete";
